"use client";

import React from "react";
import { Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CtaContacto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="contacto-cta" id="cta-contacto" className="relative bg-background text-foreground py-32 md:py-40 overflow-hidden border-t border-border/30">
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: "url(https://fulcro.mx/wp-content/uploads/2026/04/fulcro-textura-fulcrums-dark.svg)",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      opacity: 0.15
    }} aria-hidden="true" />

      <div ref={ref} className={`relative z-10 max-w-3xl mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal text-foreground leading-tight mb-8">O escríbenos directo.</h2>

        <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed mb-12 max-w-2xl mx-auto">Si prefieres correo o quieres ubicar dónde estamos, aquí está.</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16">
          <div className="flex items-center gap-3">
            <Mail className="size-5 shrink-0 text-primary" />
            <Link to="mailto:hola@fulcro.mx" className="font-sans text-base md:text-lg text-foreground hover:text-primary transition-colors">
              hola@fulcro.mx
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <MapPin className="size-5 shrink-0 text-primary" />
            <span className="font-sans text-base md:text-lg text-muted-foreground">
              Riviera Maya, México
            </span>
          </div>
        </div>
      </div>
    </section>;
}